import { Component, ojs, app } from "modular-openscriptjs";
import { either, isMobile, searchPlaceholder, fireEvent, getStoreSync } from "../../helpers";
import SideNav from "../SideNav";
import TermsAndConditionsCard from "./TermsAndConditionsCard";
import { resolveCurrentPage } from "../../declarations";

const h = app("h");

ojs(SideNav, TermsAndConditionsCard);

export default class MainContent extends Component {
	/**
	 *
	 * @param {import("modular-openscriptjs").State<boolean>} collapsed
	 * @param {import("modular-openscriptjs").State<boolean>} authState
	 * @param  {...any} args
	 * @returns {HTMLElement}
	 */
	render(authState, ...args) {
		return h.div(
			{ class: "container-xl", $class: 'd-block w-100', $ojs_hook: "main-content-container" },
			// The side nav is shown to guests too, so always leave room for it.
			{
				$class: `d-block flex-fill ${pc.sideNavCollapsed.value? "col-md-11 col-lg-11" : "col-md-6 col-lg-9"}`,
				$style: "transition: width 0.3s ease;",
			},
			h.call(() => {
				// The user must accept Carata's terms and conditions before
				// any page is allowed to resolve/render. We check this here
				// (rather than in route middleware) because this runs as
				// part of the app's actual render cycle, by which point the
				// terms and conditions form (mounted in AppOffCanvas) is
				// guaranteed to already be listening for the event below.
				if (getStoreSync("paymentTc") != 1) {
					fireEvent(app("$e").termsAndConditions.needs.acceptance);
					return h.TermsAndConditionsCard();
				}

				searchPlaceholder("Search for anything...");
				return resolveCurrentPage()
			}),
			...args,
		);
	}
}
